<template>
  <footer class="text-center text-lg-start ">
    <div class="text-center p-3" >
      © 2021 Copyright:
      <a class="text-dark" href="https://github.com/sadegh1377" target="_blank">MSH</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

footer {
  background-color: #a3a2a2;
  direction: ltr !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  opacity: .8;
  border-radius: 20px;
}
</style>